"use strict";

var _regeneratorRuntime = require("/Users/chrislawlor/Dev/gyphto/gyphto-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/Users/chrislawlor/Dev/gyphto/gyphto-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/chrislawlor/Dev/gyphto/gyphto-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lib_1 = require("./lib");
/**
 *
 * This is the main Bitly module that returns an object of methods.  You need to pass in your
 * OAuth access token, as well as an optional config object. You are returned several helper
 * methods, as well as access to a method to pass any bitly api request to.
 *
 * For information on the data returned from the API, see the docs at
 * https://dev.bitly.com/api.html
 *
 * @module node-bitly
 * @type {function}
 * @param accessToken The access token, this from an OAuth session
 * @param config Optional config object
 * @returns A given Bitly response
 * @example
 * ```js
 *  const BitlyClient = require('bitly').BitlyClient;
 *  const bitly = new BitlyClient('<accessToken>');
 *  const myFunc = async(uri = 'https://github.com/tanepiper/node-bitly') => {
 *    try {
 *      return await bitly.shorten(uri);
 *   } catch(e) {
 *      throw e;
 *    }
 *  }
 * ```
 */


var BitlyClient =
/*#__PURE__*/
function () {
  function BitlyClient(accessToken) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, BitlyClient);

    this.accessToken = accessToken;
    this.config = config;
  }
  /**
   * This is used to get the summary of info about a given bitlink
   * Ref: https://dev.bitly.com/v4/#operation/getBitlink
   * @param  item ID, short Url, or hash
   * @return Summarized info about a given bitlink
   */


  _createClass(BitlyClient, [{
    key: "getBitlink",
    value: function getBitlink(item) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.bitlyRequest("bitlinks/".concat(lib_1.forceToBitlinkId(item)), {}, 'GET');

              case 2:
                return _context.abrupt("return", _context.sent);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
    /**
     * This is used to get the summary of info about a given bitlink
     * Legacy wrapper around getBitlink
     * @param item ID, short Url, or hash
     * @return Summarized info about a given bitlink
     */

  }, {
    key: "info",
    value: function info(item) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.getBitlink(item);

              case 2:
                return _context2.abrupt("return", _context2.sent);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
    /**
     * Used to shorten a url
     * @param  longUrl The URL to be shortened
     * @return Shorten results
     */

  }, {
    key: "shorten",
    value: function shorten(longUrl) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.bitlyRequest('shorten', {
                  long_url: longUrl
                });

              case 2:
                return _context3.abrupt("return", _context3.sent);

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
    /**
     * Request to expand urls and hashes
     * @param item ID, short Url, or hash
     * @return The results of the request
     */

  }, {
    key: "expand",
    value: function expand(item) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.bitlyRequest('expand', {
                  bitlink_id: lib_1.forceToBitlinkId(item)
                });

              case 2:
                return _context4.abrupt("return", _context4.sent);

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
    /**
     * Request to get clicks for urls and hashes
     * Defaults are per docs, and are the same result as if you call endpoint with no args
     * @param item ID, short Url, or hash
     * @param unit The unit of time for which to pull click stats
     * @param units The time units to pull data for
     * @param size How many results to limit the response to
     * @param unit_reference Optional - ISO-8601 timestamp, indicating the most recent time to pull stats for
     * @return The results of the request
     */

  }, {
    key: "clicks",
    value: function clicks(item) {
      var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'day';
      var units = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
      var size = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 50;
      var unit_reference = arguments.length > 4 ? arguments[4] : undefined;
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.bitlyRequest("bitlinks/".concat(lib_1.forceToBitlinkId(item), "/clicks"), {
                  unit: unit,
                  units: units,
                  size: size,
                  unit_reference: unit_reference
                }, 'GET');

              case 2:
                return _context5.abrupt("return", _context5.sent);

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
    /**
     * Request to get clicks by minute for urls and hashes
     * @param item ID, short Url, or hash
     * @return Clicks by minute stats
     */

  }, {
    key: "clicksByMinute",
    value: function clicksByMinute(item) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.clicks(item, 'minute');

              case 2:
                return _context6.abrupt("return", _context6.sent);

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
    /**
     * Request to get clicks by day for urls and hashes
     * @param item ID, short Url, or hash
     * @return clicks by day stats
     */

  }, {
    key: "clicksByDay",
    value: function clicksByDay(item) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.clicks(item, 'day');

              case 2:
                return _context7.abrupt("return", _context7.sent);

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    }
    /**
     * Lookup a single url
     * DEPRECATED
     * @param url The url to look up
     * @return Deprecated Error
     */

  }, {
    key: "lookup",
    value: function lookup(url) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", lib_1.throwDeprecatedErr('lookup', 'getBitlink'));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));
    }
    /**
     * Request referrers for a single url
     * @param item ID, short Url, or hash
     * @return Metrics by referrers
     */

  }, {
    key: "referrers",
    value: function referrers(item) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9() {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.bitlyRequest("bitlinks/".concat(lib_1.forceToBitlinkId(item), "/referrers"), {}, 'GET');

              case 2:
                return _context9.abrupt("return", _context9.sent);

              case 3:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));
    }
    /**
     * Request countries for a single url
     * @param item ID, short Url, or hash
     * @returns Stats by countries
     */

  }, {
    key: "countries",
    value: function countries(item) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10() {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.bitlyRequest("bitlinks/".concat(lib_1.forceToBitlinkId(item), "/countries"), {}, 'GET');

              case 2:
                return _context10.abrupt("return", _context10.sent);

              case 3:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));
    }
    /**
     * Perform any bitly API request using a method name and passed data object
     * @param method The method name to be called on the API. Not to be confused with reques method (aka HTTP verb)
     * @param data The data object to be passed. Keys should be query or body parameters.
     * @param reqMethod The HTTP request method to be used (aka *HTTP Verb*)
     * @typeparam ResponseType - The expected response type
     * @return The bitly request return data
     */

  }, {
    key: "bitlyRequest",
    value: function bitlyRequest(method, data) {
      var reqMethod = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'POST';
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee11() {
        var err;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;
                _context11.next = 3;
                return lib_1.doRequest(this.accessToken, method, data, this.config, reqMethod);

              case 3:
                return _context11.abrupt("return", _context11.sent);

              case 6:
                _context11.prev = 6;
                _context11.t0 = _context11["catch"](0);
                err = _context11.t0;

                if (!err.response) {
                  _context11.next = 11;
                  break;
                }

                throw err.response.data;

              case 11:
                throw err;

              case 12:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this, [[0, 6]]);
      }));
    }
  }]);

  return BitlyClient;
}();

exports.BitlyClient = BitlyClient;
/**
 * Bitly object definition
 * @typedef {object} Bitly
 * @property {Function} getBitlink Function that is used to get the summary of info about a given bitlink.
 * @property {Function} shorten Function that takes a url and shortens it. Accepts valid URL.
 * @property {Function} expand Function that gets long urls for short urls. Accepts valid Bitlink.
 * @property {Function} clicks Function that gets the number of clicks of short urls. Accepts valid Bitlink.
 * @property {Function} clicksByMinute Function that gets the number of clicks by minute for short urls. Accepts valid Bitlink.
 * @property {Function} clicksByDay Function that gets the number of clicks by day for short urls. Accepts valid Bitlink.
 * @property {Function} lookup !!! - DEPRECATED --- !!! Function that takes a url looks up data. Accepts valid URL.
 * @property {Function} info Function that takes a url and gets info. Accepts valid Bitlink.
 * @property {Function} referrers Function that gets referrers for urls. Accepts valid Bitlink.
 * @property {Function} countries Function that gets click by countries for urls. Accepts valid Bitlink.
 * @property {Function} bitlyRequest Function that allows you to to any bitly request
 */